<template>
  <div class="bottom-corp">
    <div class="lxwm">
      <div class="lxwm-left">
        <img class="logo" src="@/assets/tslogo.png" alt="" />
        <div class="lxwm-line">北数所泰山数据要素服务中心</div>
        <div class="lxwm-line">业务咨询电话：13375386550（李老师）</div>
        <div class="lxwm-line">地址：山东省泰安市高新区国家高创中心</div>
        <div class="lxwm-line">邮箱：taishandata@126.com</div>
      </div>
      <div class="lxwm-right">
        <div class="qr-code-item">
          <div class="qr-code-title">公众号</div>
          <img src="@/assets/ewm1.jpg" alt="公众号" class="qr-code-img" />
        </div>
        <div class="qr-code-item">
          <div class="qr-code-title">生态合作</div>
          <img src="@/assets/ewm2.jpg" alt="生态合作" class="qr-code-img" />
        </div>
        <div class="qr-code-item">
          <div class="qr-code-title">实训合作</div>
          <img src="@/assets/ewm3.jpg" alt="实训合作" class="qr-code-img" />
        </div>
      </div>
    </div>
    <div class="yqlj-section">
      <div class="yqlj-container">
        <div class="yqlj-title">友情链接</div>
        <div class="yqlj-list">
          <a
            v-for="(item, index) in yqljList"
            :key="index"
            :href="item.link"
            target="_blank"
            class="yqlj-item"
          >
            {{ item.title }}
          </a>
        </div>
      </div>
    </div>
    <div class="babox">
      <!-- <div style="margin-bottom: 2px">© 2026 泰安协同软件有限公司 版权所有</div> -->
      <div>
        <span>© 2026 泰山数据要素产业园 &nbsp;&nbsp;&nbsp;</span>
        备案号:<a
          class="link"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          >鲁ICP备09006057号-14
        </a>
        <!-- | 备案号：<a
          class="link"
          href="https://beian.mps.gov.cn/#/query/webSearch"
          target="_blank"
          >鲁公网安备37099202000444号</a
        > -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterBar",
  data() {
    return {
      yqljList: [
        {
          title: "国家数据局",
          link: "https://www.nda.gov.cn/",
        },
        {
          title: "北京国际大数据交易所",
          link: "https://www.bjidex.com/",
        },
        {
          title: "北京优锘科技股份有限公司",
          link: "https://www.uino.com/",
        },
        {
          title: "北京熠智科技有限公司",
          link: "https://yeez.tech/",
        },
        {
          title: "北京大成律师事务所",
          link: "https://www.dacheng.com/",
        },
        {
          title: "泰安高新技术产业开发区",
          link: "https://gxq.taian.gov.cn/",
        },
        {
          title: "泰安协同软件有限公司",
          link: "http://taxtsoft.com/",
        },
      ],
    };
  },
  methods: {
    goMoreLink(link) {
      if (link === this.$route.fullPath) return;
      this.$router.push(link);
    },
  },
};
</script>
<style lang="less" scoped>
.bottom-corp {
  justify-content: center;
  box-sizing: border-box;
  height: auto;
  color: #999;
  font-size: 14px;
  font-weight: 400;
  background: #f9f9f9;
  box-shadow: 0 -1px 0 0 #ebebeb;
  border-top: 1px solid #ebebeb;
  .logo {
    width: 201px;
  }
  .lxwm {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 1200px;
    padding: 40px 0;
    margin: 0 auto;

    .lxwm-left {
      display: flex;
      flex-direction: column;
      justify-content: center;

      gap: 16px;
      .lxwm-line {
        color: #333;
        font-size: 16px;
        line-height: 1.5;
      }
    }
    .lxwm-right {
      display: flex;
      align-items: center;

      gap: 40px;
      .qr-code-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .qr-code-title {
          margin-bottom: 12px;
          color: #333;
          font-size: 14px;
          font-weight: 500;
        }
        .qr-code-img {
          width: 120px;
          height: 120px;
          border-radius: 4px;

          object-fit: cover;
        }
      }
    }
  }
  .yqlj-section {
    width: 100%;
    padding: 30px 0;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    .yqlj-container {
      box-sizing: border-box;
      width: 1200px;
      margin: 0 auto;
      .yqlj-title {
        margin-bottom: 20px;
        color: #333;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
      }
      .yqlj-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        gap: 20px 40px;
        .yqlj-item {
          color: #666;
          font-size: 14px;
          text-decoration: none;
          transition: color 0.3s ease;
          &:hover {
            color: #0079f3;
          }
        }
      }
    }
  }
  .babox {
    box-sizing: border-box;
    width: 1200px;
    height: 78px;
    padding-top: 30px;
    margin: 0 auto;
    text-align: center;
    border-top: 1px solid #ebebeb;
  }
}
.link {
  color: inherit;
  text-decoration: none;
}
</style>
